import React, { ReactElement } from 'react'
import { Form, useFormikContext } from 'formik'
import { Button, Stack } from '@mindfulchefuk/design-system'
import {
  FormControl,
  FormInput,
  FormLabel,
  validateEmail,
  validatePassword,
} from '@mindfulchefuk/forms'
import { Spinner } from '@mindfulchefuk/components/Loader'
import { useHasClientHydrated } from '@mindfulchefuk/hooks/useHasClientHydrated'

export const SignInForm = ({
  isDisabled,
}: {
  isDisabled?: boolean
}): ReactElement => {
  const { isSubmitting } = useFormikContext()
  const hasClientHydrated = useHasClientHydrated()
  const disabled = isDisabled || isSubmitting || !hasClientHydrated

  return (
    <Form data-testid="sign-in-form">
      <Stack spacing={{ base: 16, sm: 24 }} my={{ base: 24, sm: 32 }}>
        <FormControl
          id="email"
          name="email"
          type="email"
          validationSchema={validateEmail}
        >
          <FormLabel>Email Address</FormLabel>
          <FormInput />
        </FormControl>

        <FormControl
          id="password"
          name="password"
          type="password"
          validationSchema={validatePassword}
        >
          <FormLabel>Password</FormLabel>
          <FormInput autoComplete="current-password" />
        </FormControl>
      </Stack>

      <Button
        disabled={disabled}
        type="submit"
        variant="primary"
        size="medium"
        fullWidth
      >
        {disabled ? <Spinner size={24} /> : 'Sign in'}
      </Button>
    </Form>
  )
}
